module.exports = __webpack_public_path__ + "img/IPO_EN.cf286e45.png";